import React, { useEffect, useRef } from "react";
import { IGalleryData } from "../../exports/interfaces";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import { Link } from "react-router-dom";
import calendarIcon from "../../assets/img/icons/calendar.svg";

const GalleryView = ({
  id,
  galleryImagesData,
}: {
  id: number;
  galleryImagesData: IGalleryData[];
}) => {
  const galleryGridRef = useRef<HTMLElement | null>(null);
  const images = galleryImagesData?.map((data) => {
    return {
      id: data?.id,
      Name: data?.title,
      Date: data?.date,
      image: data?.images?.map((img) => img?.media?.url),
    };
  });
  const filteredGallery = images.find((img) => img.id === id);
  // const formatedDate = formatDateDetails(filteredGallery?.Date || "");
  useEffect(() => {
    if (id !== undefined) {
      galleryGridRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [filteredGallery?.Name, id]);
  return (
    <>
      <section ref={galleryGridRef}>
        <div className="td_height_120 td_height_lg_80" />
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <h2 className="td_section_title td_fs_48 mb-0">
            {filteredGallery?.Name}
          </h2>
          {filteredGallery?.Date && (
            <div className="td_post_meta td_fs_14 td_medium td_mb_20 d-flex align-items-center gap-2 justify-content-center">
              <img src={calendarIcon} alt="calendar icon" />{" "}
              {filteredGallery?.Date}
            </div>
          )}
          <div className="td_height_120 td_height_lg_80" />
        </div>
        <div className="container">
          <LightGallery
            speed={500}
            plugins={[lgThumbnail]}
            download={false}
            elementClassNames="row td_gap_y_30"
          >
            {filteredGallery?.image?.map((image, index) => (
              <Link
                key={index}
                to={`${process.env.REACT_APP_cmsUrl}${image}`}
                className="col-lg-3 td_post_thumb d-block"
              >
                <div className="td_post td_style_1">
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}${image}`}
                    alt={`Image-${index + 1}`}
                    style={{
                      height: 305,
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </Link>
            ))}
          </LightGallery>
        </div>
        <div className="td_height_120 td_height_lg_80" />
      </section>
    </>
  );
};

export default GalleryView;
